interface FormatBadgeProps {
  label: string;
}

export function FormatBadge({ label }: FormatBadgeProps) {
  return (
    <span
      className="rounded bg-ink-700 px-1.5 py-0.5 text-[10px] font-medium text-ink-200 ring-1 ring-ink-600"
      title={`Formato: ${label}`}
    >
      {label}
    </span>
  );
}

